import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCamperList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/campers', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCamperProfile(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/campers/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchApplicationStatuses() {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/application-statuses')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProgramList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/programs', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchGroupList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/groups', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
